
export enum ReingresoSerieChoice {
  EN_ESPERA = 'EN ESPERA',
  APROBADO = 'APROBADO',
  RECHAZADO = 'RECHAZADO'
}